import Modal from '@components/Modals/Modal.js';

export default class YesNoPromptModal extends Modal {
  constructor(title, message = '', options = {}) {
    const {
      allowAbort = false,
      cancelText = i18next.t('common.no'),
      confirmText = i18next.t('common.yes'),
      ...otherOptions
    } = options;

    super(title, {
      description: message,
      cancelText,
      confirmText,
      ...otherOptions,
      showCancel: true,
      showConfirm: true,
      showCloseIcon: allowAbort,
      handleOnAction: () => {
        // Return a resolved promise to indicate success
        return Promise.resolve();
      },
    });
  }

  // Alias method for backward compatibility
  static async show(title, message, allowAbort = true) {
    const modal = new YesNoPromptModal(title, message, { allowAbort });
    return await modal.show();
  }
}
